import { createCastManagerImpl } from '@msgn/fl-module/fl-chrome-sender';

import { CastManager } from './playerApi.types';

export const createCastManager = (): CastManager => {
  return createCastManagerImpl();
};
